export class WidgetsConstants {
    public static CalendarWidgetName = "calendar";
    public static BookingWidgetName = "booking";
    public static PaymentWidgetName = "payment";
} 